import { FC } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { PageHeader } from '@/components/common/PageHeader'
import { GuardaPrivacidade } from '@/components/privacidade/comum'

export const ROTA_PRIVACIDADE_LGPD = '/privacidade-lgpd'

/** Abas do menu "Privacidade (LGPD)" (AN-12 §12), na ordem do desenho. */
export const ABAS_PRIVACIDADE: { caminho: string; rotulo: string }[] = [
  { caminho: 'solicitacoes', rotulo: 'Solicitações do titular' },
  { caminho: 'expurgos', rotulo: 'Fila de expurgo' },
  { caminho: 'retencoes-legais', rotulo: 'Retenção legal' },
  { caminho: 'politicas', rotulo: 'Política de retenção' },
  { caminho: 'registros', rotulo: 'Trilha de expurgos' },
]

/**
 * Casca do back-office de privacidade: cabeçalho, abas e a página da aba. Só ADMIN e DPO —
 * os demais veem "sem permissão" e nenhuma aba é montada.
 */
export const PrivacidadeLgpdLayout: FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const atual =
    ABAS_PRIVACIDADE.find((a) => location.pathname.startsWith(`${ROTA_PRIVACIDADE_LGPD}/${a.caminho}`))?.caminho ??
    ABAS_PRIVACIDADE[0].caminho

  return (
    <Box>
      <PageHeader
        title="Privacidade (LGPD)"
        eyebrow="Administração"
        subtitle="Retenção, retenção legal, expurgo e solicitações do titular"
      />
      <GuardaPrivacidade>
        <Tabs
          value={atual}
          onChange={(_, v: string) => navigate(`${ROTA_PRIVACIDADE_LGPD}/${v}`)}
          variant="scrollable"
          allowScrollButtonsMobile
          sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
          aria-label="Seções de privacidade"
        >
          {ABAS_PRIVACIDADE.map((a) => (
            <Tab key={a.caminho} value={a.caminho} label={a.rotulo} />
          ))}
        </Tabs>
        <Outlet />
      </GuardaPrivacidade>
    </Box>
  )
}

export default PrivacidadeLgpdLayout
